import Component from './Component'

export default class Form extends Component {

	static _type = 'Form'

	//_inputs = { }
	_name
	data

	constructor (name, data, params = {}) {
		super(params)
		this._name = name
		this.data = data
	}

	tether () {
		super.tether()

		// Create bound event handlers and register them
		this.submitListener = Form._submitListener.bind(this)
		$(this.base).on('submit', this.submitListener)				// jQuery event

	}

	static _submitListener (event) {
		// Prevent an actual form submit, as this would reload the entire app
		event.preventDefault()

		// See if we have an action set for this
		if ('submit' in this.params && typeof this.params.submit == 'function') {
			this.params.submit()
		}
	}

	/*
	registerInput (field, input) {
		this._inputs[field] = input
	}

	unregisterInput (field, input) {
		delete this._inputs[field]
	}
	*/

	get name () { return this._name }

	destroy () {

		// Unregister event handlers
		$(this.base).off('submit', this.submitListener)

		super.destroy()
	}
}
